import React from 'react'
import { SEO } from '../../../../components/Seo/seo'
import { notifications } from '../../../../utils/pages-meta.json'
import CompanyNotificationsContent from '../../../../components/Workspace/CompanyPage/CompaniesNotifications'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { useParams } from 'react-router-dom'
import NoMatch from '../../../NoMatch'
import { FormattedMessage, useIntl } from 'react-intl'
import { SearchLoader } from '../../../../components/Loader/SearchLoader'
import InActiveUserContent from '../../../../components/InActiveUserContent'
import { Container } from '@material-ui/core'
import { useStyles } from '../Styles'

const Notifications = () => {
  let { id } = useParams()
  const intl = useIntl()
  const classes = useStyles()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'PageTitle.Notifications' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax-Workspace' })}
               image={notifications.image}
               description={intl.formatMessage({ id: 'PageTitle.Notifications' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, isUserActive, userData, checkCompanyData }) => (
              <>
                <Container maxWidth="lg" className={classes.TitleContainer}>
                  <h1><FormattedMessage id='PageTitle.Notifications'/></h1>
                </Container>
                {!!userDataLoading && <SearchLoader loading={true}/>}
                {(!!Object.keys(userData).length && !!isUserActive) ?
                  <CompanyNotificationsContent checkCompanyData={checkCompanyData} cid={id}/>
                  : (!userDataLoading && <InActiveUserContent/>)
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <NoMatch/>
      }
    </>
  )
}

export default Notifications
